import { Link } from 'react-router-dom';
import { categories } from '@/mocks/cases';

export default function SiteFooter() {
  return (
    <footer className="mt-20 bg-secondary-900 text-secondary-100">
      <div className="mx-auto max-w-[1280px] px-4 py-12 md:px-6 md:py-14">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div>
            <div className="flex items-center gap-2.5">
              <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-alarm-warning-line text-xl"></i>
              </span>
              <span className="font-heading text-lg font-bold text-background-50">网红爆料网</span>
            </div>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-secondary-200">
              坚持以实锤为本，集中收录录音、视频证据、合同照片与转账记录，让每一条爆料都尽量经得起推敲。
            </p>
            <p className="mt-4 text-xs text-secondary-300">本站内容中当事人均为化名，隐私信息已做遮挡处理。</p>
          </div>

          <nav aria-label="页脚导航">
            <h2 className="font-heading text-sm font-semibold text-background-50">内容导航</h2>
            <ul className="mt-4 space-y-2.5 text-sm">
              <li><Link to="/" className="text-secondary-200 hover:text-accent-300">首页</Link></li>
              <li><Link to="/cases" className="text-secondary-200 hover:text-accent-300">全部爆料</Link></li>
              <li><Link to="/about" className="text-secondary-200 hover:text-accent-300">关于我们</Link></li>
              <li><Link to="/about#submit" className="text-secondary-200 hover:text-accent-300">投稿爆料</Link></li>
            </ul>
          </nav>

          <nav aria-label="主题分类导航">
            <h2 className="font-heading text-sm font-semibold text-background-50">主题分类</h2>
            <ul className="mt-4 space-y-2.5 text-sm">
              {categories.slice(0, 5).map((cat) => (
                <li key={cat.id}>
                  <Link to={`/cases?cat=${cat.id}`} className="text-secondary-200 hover:text-accent-300">
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          <div>
            <h2 className="font-heading text-sm font-semibold text-background-50">联系与投稿</h2>
            <ul className="mt-4 space-y-3 text-sm text-secondary-200">
              <li className="flex items-start gap-2">
                <i className="ri-mail-line mt-0.5 text-accent-400"></i>
                <a href="mailto:contact@baoliao.example.com" className="hover:text-accent-300">contact@baoliao.example.com</a>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-file-shield-2-line mt-0.5 text-accent-400"></i>
                <span>异议与撤稿：appeal@baoliao.example.com</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-time-line mt-0.5 text-accent-400"></i>
                <span>材料对接：工作日 10:00 - 19:00</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-secondary-700 pt-6 text-xs text-secondary-300 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 网红爆料网 · 内容仅代表投稿人陈述，网站不对材料之外的结论作出判断</p>
          <p className="flex flex-wrap gap-4">
            <Link to="/about" className="hover:text-accent-300">内容原则</Link>
            <Link to="/about#submit" className="hover:text-accent-300">投稿须知</Link>
            <a href="mailto:appeal@baoliao.example.com" className="hover:text-accent-300">异议处理</a>
          </p>
        </div>
      </div>
    </footer>
  );
}